import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=6081638d&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"
import style0 from "./PageList.vue?vue&type=style&index=0&id=6081638d&prod&lang=scss"
import style1 from "./PageList.vue?vue&type=style&index=1&id=6081638d&prod&lang=scss&scoped=true"
import style2 from "./PageList.vue?vue&type=style&index=2&id=6081638d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081638d",
  null
  
)

export default component.exports